// Which chapters and parts take a number (`ChapterNumbering`, SuiteModel Numbering.swift): every chapter is numbered
// unless marked otherwise — a prologue, an interlude — and compile and the contents count past an unnumbered one, so
// "Chapter One" is the first numbered chapter in both. The mark is the fragment's metadata key `numbered` = false, a
// marker like `book-matter` rather than a declared field, so it never shows as a column; absent means numbered.
import type { MetadataValue } from './contract.ts';

/** The marker key (`StandardField.numbered`). */
export const NUMBERED_FIELD = 'numbered';

export function isNumberedChapter(metadata: Readonly<Record<string, MetadataValue>> | undefined): boolean {
  const v = metadata?.[NUMBERED_FIELD];
  return !(v?.type === 'boolean' && v.value === false);
}
